export interface LotteryModality {
    key: number;
    value: string;
    label: string;
    qty_comb_min: number;
    qty_comb_max: number;
    qty_result: number;
    qty_disp: number;
    qty_min_gain: number;
    public_only?: boolean;
    disabled?: boolean;
}

export interface LotteryModalityWithState extends LotteryModality {
    combinacoes: unknown[];
    probabilities: unknown[];
}

export const LOTTERY_MODALITIES: LotteryModality[] = [
    {
        key: 0,
        value: 'dupla_sena',
        label: 'Dupla Sena',
        qty_comb_min: 6,
        qty_comb_max: 15,
        qty_result: 6,
        qty_disp: 50,
        qty_min_gain: 3,
        public_only: true,
    },
    {
        key: 1,
        value: 'lotofacil',
        label: 'Lotofácil',
        qty_comb_min: 15,
        qty_comb_max: 20,
        qty_result: 15,
        qty_disp: 25,
        qty_min_gain: 11,
        public_only: true,
    },
    {
        key: 2,
        value: 'lotomania',
        label: 'Lotomania',
        qty_comb_min: 50,
        qty_comb_max: 50,
        qty_result: 20,
        qty_disp: 100,
        qty_min_gain: 0,
        public_only: true,
    },
    {
        key: 3,
        value: 'mega_sena',
        label: 'Mega Sena',
        qty_comb_min: 6,
        qty_comb_max: 20,
        qty_result: 6,
        qty_disp: 60,
        qty_min_gain: 4,
        public_only: true,
    },
    {
        key: 4,
        value: 'quina',
        label: 'Quina',
        qty_comb_min: 5,
        qty_comb_max: 15,
        qty_result: 5,
        qty_disp: 80,
        qty_min_gain: 2,
        public_only: true,
        disabled: false,
    },
];

export const createLotteryModalitiesWithState = (): LotteryModalityWithState[] =>
    LOTTERY_MODALITIES.map((modalidade) => ({
        ...modalidade,
        combinacoes: [],
        probabilities: [],
    }));

export const getLotteryModalityByValue = (value: string) =>
    LOTTERY_MODALITIES.find((modalidade) => modalidade.value === value);

export const getLotteryModalityLabel = (value: string) =>
    getLotteryModalityByValue(value)?.label ?? value;
